import { useEffect, useState } from "react";
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import { Alert, Card, Col, Label, Row } from "reactstrap"

const ShapeUpload = (props: any) => {

  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // useEffect(() => {
  //   if (props?.onReset === true) {
  //     setSelectedFiles([]);
  //     if (typeof props.onResetValueChange === "function") {
  //       props.onResetValueChange(false);
  //     }
  //   } else {
  //     props?.selectFiles(selectedFiles);
  //   }
  // }, [props?.onReset, selectedFiles])

  useEffect(() => {
    if (props?.onReset) {
      setSelectedFiles([]);
      if (typeof props.onResetValueChange === "function") {
        props.onResetValueChange(false);
      }
    }
  }, [props?.onReset]);

  useEffect(() => {
    props?.selectFiles(selectedFiles);
  }, [selectedFiles]);

  function handleAcceptedFiles(files: any) {
    const updatedFiles = files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(updatedFiles);
  }

  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleRemoveFile = (index: number) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  if (props?.compact) {
    return (
      <Dropzone
        onDrop={(acceptedFiles: any) => handleAcceptedFiles(acceptedFiles)}
        accept={{ 'application/octet-stream': ['.shp', '.shx', '.dbf'] }}
        noClick
      >
        {({ getRootProps, getInputProps, open, isDragActive }: any) => (
          <div
            {...getRootProps()}
            className={`d-flex align-items-center flex-wrap gap-1 border rounded px-2 py-1 ${isDragActive ? 'border-primary bg-light' : ''}`}
            style={{ borderStyle: 'dashed', minHeight: 34 }}
          >
            <input {...getInputProps()} />
            <button type="button" className="btn btn-sm btn-soft-primary py-0" onClick={open}>
              <i className="mdi mdi-upload me-1" />{props?.label || 'Shape файл'}
            </button>
            {selectedFiles.length === 0 && <small className="text-muted">.shp .shx .dbf</small>}
            {selectedFiles.map((f: any, i: number) => (
              <span key={i + '-file'} className="badge bg-light text-dark border d-inline-flex align-items-center">
                {f.name}
                <i className="mdi mdi-close ms-1" style={{ cursor: 'pointer' }} onClick={() => handleRemoveFile(i)} />
              </span>
            ))}
          </div>
        )}
      </Dropzone>
    );
  }

  return (
    <>
      <Col lg={12}>
        <div className="mb-3">
          <Label> {props?.label || "Shape файл оруулах"} </Label>
          <Dropzone
            onDrop={(acceptedFiles: any) => {
              handleAcceptedFiles(acceptedFiles)
            }}
            accept={{
              'application/octet-stream': ['.shp', '.shx', '.dbf']
            }}
          >
            {({ getRootProps, getInputProps }: any) => (
              <div className="dropzone">
                <div
                  className="dz-message needsclick mt-2"
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <div className="mb-3">
                    <i className="display-4 text-muted mdi mdi-cloud-upload-outline" />
                  </div>
                  <Alert color="info" className="mb-0 fs-5">
                    <i className="mdi mdi-alert-circle-outline me-2"></i>
                    Таны оруулж буй файлын өргөтгөл нь  {" "}
                    <Link to="#" className="alert-link">
                      .shp .shx .dbf
                    </Link>  {" "}
                    байх ба
                    {" "}
                    <Link to="#" className="alert-link text-uppercase">
                      #{props?.fileType}
                    </Link>  {" "} байхыг анхаарна уу !
                  </Alert>
                </div>
              </div>
            )}
          </Dropzone>
          <div className="dropzone-previews mt-3" id="file-previews">
            {selectedFiles?.map((f: any, i: any) => {
              return (
                <Card
                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                  key={i + "-file"}
                >
                  <div className="p-2">
                    <Row className="align-items-center">
                      <Col className="col-auto">
                        <img
                          data-dz-thumbnail=""
                          height="80"
                          className="avatar-sm rounded bg-light"
                          alt={f.name}
                          src={f.preview}
                        />
                      </Col>
                      <Col>
                        <Link
                          to="#"
                          className="text-muted font-weight-bold"
                        >
                          {f.name}
                        </Link>
                        <p className="mb-0">
                          <strong>{f.formattedSize}</strong>
                        </p>
                      </Col>
                      <Col className="col-auto">
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveFile(i)}
                        >
                          Устгах
                        </button>
                      </Col>
                    </Row>
                  </div>
                </Card>
              )
            })}
          </div>
        </div>
      </Col>

    </>
  )
}

export default ShapeUpload;